import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Applications/CompactSearch/CompactSearch.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Applications/CompactSearch/CompactSearch.ts';

export const prototypeName = 'GLOdwKxn2bC59enGPlogIVGrr4WX9kSZKoPOX4L5ckznzROQAdF96KpW7WXeU5OlpwbLv9Co58Pw';
export {styles};
export {script};